import ApiClient from '@/utils/api-client'
export default {
  // 历史
  // 获取历史列表
  getHistoryFoot(params?:any): any {
    return ApiClient.get(`/user/history/get_history`,params)
  },
  // 删除历史记录
  delHistoryFoot(params?:any): any {
    return ApiClient.get(`/user/history/del_history`,params)
  },
  // 清空历史记录
  clearHistoryFoot(params?:any): any {
    return ApiClient.get(`/user/history/clear_history`,params)
  },
  // 收藏
  // 用户
  // 发送短信
  sendSms(params?:any): any {
    return ApiClient.get(`/user/index/send_sms`,params)
  },
  // 手机号码登入
  mobileLogin(params?:any): any {
    return ApiClient.get(`/user/index/mobile_login`,params)
  },
  // 用户名密码登入
  userNameLogin(params?:any): any {
    return ApiClient.get(`/user/index/user_name_login`,params)
  },
  // 获取用户信息
  getUserInfo(params?:any): any {
    return ApiClient.get(`/user/index/get_user_info`,params)
  },
  // 上传头像
  uploadAvatar(params?:any): any {
    return ApiClient.post(`/user/index/upload_avatar`,params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 图片上传
  uploadImage(params?:any): any {
    return ApiClient.post(`/upload/image`,params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 更新用户信息
  updateUserInfo(params?:any): any {
    return ApiClient.post(`/user/index/update_user_info`,params)
  },
  // 获取用户地址
  getUserAddress(params?:any): any {
    return ApiClient.get(`/user/index/get_user_address`,params)
  },
  // 获取用户地址
  saveAddress(params?:any): any {
    return ApiClient.post(`/user/index/save_address`,params)
  },
  // 删除用户地址
  delUserAddress(params?:any): any {
    return ApiClient.get(`/user/index/del_user_address`,params)
  },
  // 获取用户地址详情 编辑地址时用
  getUserAddressInfo(params?:any): any {
    return ApiClient.get(`/user/index/get_user_address_info`,params)
  },
  // 绑定手机
  bindMobile(params?:any): any {
    return ApiClient.get(`/user/index/bind_mobile`,params)
  },
  // 验证旧手机
  changeMobileCheckOldMobile(params?:any): any {
    return ApiClient.get(`/user/index/change_mobile_check_old_mobile`,params)
  },
  // 发送邮件
  sendEmail(params?:any): any {
    return ApiClient.get(`/user/index/send_email`,params)
  },
  // 换绑邮件时验证旧邮件
  changeEmailCheckOldEmail(params?:any): any {
    return ApiClient.get(`/user/index/change_email_check_old_email`,params)
  },
  // 绑定换绑邮箱
  bindEmail(params?:any): any {
    return ApiClient.get(`/user/index/bind_email`,params)
  },
  // 修改密码
  changePassword(params?:any): any {
    return ApiClient.get(`/user/index/change_password`,params)
  },
  // 积分日志
  getUserPayIntegralLog(params?:any): any {
    return ApiClient.get(`/user/index/get_user_pay_integral_log`,params)
  },
  // 我的余额
  getUserMoneyLog(params?:any): any {
    return ApiClient.get(`/user/index/get_user_money_log`,params)
  },
  getUserWithdrawLog(params?:any): any {
    return ApiClient.get(`/user/index/get_user_withdraw_log`,params)
  },
  // 获取用户优惠券
  getUserCouponList(params?:any): any {
    return ApiClient.get(`/user/index/get_user_coupon_list`,params)
  },

  /**
   * 通过兑换码领取优惠券
   * @param params
   * @returns
   */
  getCouponByCode(params?:any): any {
    return ApiClient.post(`/user/index/get_coupon_by_code`,params)
  },
  // 获取用户提交的验证信息
  getAuthInfo(params?:any): any {
    return ApiClient.get(`/user/index/get_auth_info`,params)
  },
  // 提交用户验证信息
  authInfo(params?:any): any {
    return ApiClient.post(`/user/index/auth_info`,params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 获取用户竞拍登记
  getAuctionLevel(params?:any): any {
    return ApiClient.get(`/user/index/get_auction_level`,params)
  },
  /**
   * 获取用户等级信息
   * @param params 
   * @returns 
   */
  getUserRankLevelInfoApi(params?:any): any {
    return ApiClient.get(`/user/index/get_user_rank_level_info`,params)
  },
  // 保存用户竞拍等级
  saveAuctionLevel(params?:any): any {
    return ApiClient.get(`/user/index/save_auction_level`,params)
  },
  // 取消用户竞拍等级
  cancelAuctionLevel(params?:any): any {
    return ApiClient.get(`/user/index/cancel_auction_level`,params)
  },
  // 获取用户支付方式
  getUserPaymentRequest(params?:any): any {
    return ApiClient.get(`/user/index/get_user_payment_request`,params)
  },
  // 保存用户筛选配置
  updateUserConfig(params?:any): any {
    return ApiClient.get(`/user/index/update_user_config`,params)
  },
  // 获取用户收藏的分类
  getUserCollectCategory(params?:any): any {
    return ApiClient.get(`/user/index/get_user_collect_category`,params)
  },
  // 获取用户仓库地址
  getUserWarehouseAddress(params?:any): any {
    return ApiClient.get(`/user/index/get_user_warehouse_address`,params)
  },
  // 获取用户晒单列表
  getUserOrderSharedList(params?:any): any {
    return ApiClient.get(`/user/index/get_user_order_shared_list`,params)
  },
    // 添加用户搜索历史
    getSearchHistoryAddHistory(params?:any): any {
      return ApiClient.post(`/user/searchHistory/add_history`,params)
    },
    // 获取用户搜索历史
    getSearchHistoryGetHistory(params?:any): any {
      return ApiClient.post(`/user/searchHistory/get_history`,params)
    },
    /**
     * 删除用户搜索历史
     * @param params
     * @returns
     */
    getSearchHistoryDelHistory(params?:any): any {
      return ApiClient.post(`/user/searchHistory/del_history`,params)
    },
    clearSearchHistory(params?:any): any {
      return ApiClient.post(`/user/searchHistory/clear_history`,params)
    },
    wechatLogin(params?:any): any {
      return ApiClient.post(`/user/index/wechat_web_login`,params)
    },
    accountBindWechatWeb(params?:any): any {
      return ApiClient.post(`/user/index/account_bind_wechat_web`,params)
    },
    wechatBindMobile(params?:any): any {
      return ApiClient.post(`/user/index/wechat_bind_mobile`,params)
    },
    lineBindMobile(params?:any): any {
      return ApiClient.post(`/user/index/line_bind_mobile`,params)
    },
    lineLogin(params?:any): any {
      return ApiClient.post(`/user/index/login_by_line_code`,params)
    },
    accountUnbindWechat(params?:any): any {
      return ApiClient.post(`/user/index/account_unbind_wechat`,params)
    },
    accountUnbindLine(params?:any): any {
      return ApiClient.post(`/user/index/account_unbind_line`,params)
    },
    accountBindLineWeb(params?:any): any {
      return ApiClient.post(`/user/index/account_bind_line_web`,params)
    },
    accountRecharge(params?:any): any {
      return ApiClient.post(`/user/index/recharge`,params)
    },
    accountAddWithdraw(params?:any): any {
      return ApiClient.post(`/user/index/add_withdraw`,params)
    },
    /**
     * 拉黑卖家
     * @param params  platform_id = 1 煤炉 seller_id
     * @returns
     */
    addBlackSeller(params?:any): any {
      return ApiClient.post(`/user/index/add_black_seller`,params)
    },
    userDeclarantInfoGetList(params?:any): any {
      return ApiClient.post(`/user/userDeclarantInfo/getList`,params)
    },
    userDeclarantInfoAdd(params?:any): any {
      return ApiClient.post(`/user/userDeclarantInfo/add`,params)
    },
    userDeclarantInfoDelete(params?:any): any {
      return ApiClient.post(`/user/userDeclarantInfo/delete`,params)
    },
    userDeclarantInfoSetDefault(params?:any): any {
      return ApiClient.post(`/user/userDeclarantInfo/setDefault`,params)
    },
}
